export var MARKET_MAP_DATA = "MARKET_MAP_DATA";
export var OVERVIEW_HOLDING_DATA = "OVERVIEW_HOLDING_DATA";
export var ALERTS_OVERVIEW = "ALERTS_OVERVIEW";
export var HOLDING_DATA = "HOLDING_DATA";
